import { useEffect, useLayoutEffect } from 'react';

// fixes warnings about useLayoutEffect and ssr
export const useIsomorphicLayoutEffect = process.browser ? useLayoutEffect : useEffect;
